/** Маршрут экрана: вкладки и очередь окон. */
import type { WindowRoute } from "./window-route";

export type { WindowKind, WindowRoute, WindowRoutes } from "./window-route";

/** Вкладки внизу экрана (C5). */
export type TabId = "heroes" | "level" | "stars" | "tech";
export const TABS: readonly TabId[] = ["heroes", "level", "stars", "tech"];

/** Экран: бой — основной и единственный; поверх него очередь окон и одна открытая вкладка. */
export interface Route {
  /** Очередь окон: показывается первое, `closeWindow` открывает следующее. */
  windows: WindowRoute[];
  tab: TabId | null;
}
